import { createFileRoute } from "@tanstack/react-router";

import { PersonModule } from "/src/modules/person/person";

export const Route = createFileRoute("/_main/person/$id/detail")({
  component: PersonModule,
});
